import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'fs-auth-digest-warning',
  templateUrl: './auth-digest-warning.component.html',
  styleUrls: ['./auth-digest-warning.component.css'],
})
export class AuthDigestWarningComponent {
  constructor(private readonly _matDialogRef: MatDialogRef<AuthDigestWarningComponent>) {}

  public close(status: boolean): void {
    this._matDialogRef.close(status);
  }
}
